import { useSelector } from "react-redux";

const useSubscription = () => {
	const auth = useSelector((state: any) => state.auth);
	return auth?.company?.subscription || {};
};

export default useSubscription;
